module.exports = __webpack_public_path__ + "img/1F6AD.d9a6708f.svg";